// extracted by mini-css-extract-plugin
export default {"carrier":"Outbound_carrier__-yHn3"};